var sitepopup_timer;
var forms = {
    display_popup: true,
    reset_popup: false,
    popup_disabled: true,
    contactEnquiryEl: '.liquid_enqiury_form',
    initContactEnquiryForm: function () {
        var _this = this;
        if($(_this.contactEnquiryEl).length) {
            // === Enquiry FORM
            $(".liquid_enqiury_form").submit( function(e) {
                e.preventDefault();

                var valid = $('.liquid_enqiury_form').parsley ( 'validate' );

                if ( !$(this).parsley().isValid() ) { return; }

                if($(this).find('button[type="submit"]').hasClass( "disabled" )) { return; }

                var form = $(this);
                var formContainer = $(this).parent('.form-container');

                // show spinner
                // form.find(".form-btn .spinner").removeClass('is-hidden');
                form.find(".form-btn").addClass('loading');

                var formData = $(this).serialize() + '&action=process_liquid_enquiry_form';

                var deferred_request = $.ajax({
                    method: "POST",
                    url: admin_ajax_url,
                    data: formData,
                    datatype: "JSON"
                });

                deferred_request.done(function( data ) {

                    data = $.parseJSON(data);

                    // hide spinner
                    //form.find(".form-btn .spinner").addClass('is-hidden');
                    form.find(".form-btn").removeClass('loading');

                    if(data.success) {
                        // form.hide();
                        form.addClass('off');
                        formContainer.find('.form-success-msg').html(data.message).fadeIn();;
                        formContainer.find('.form-error-msg').fadeOut();

                        if(typeof ga === 'function') {
                            ga('send', 'pageview', '/contact/successful-enquiry');
                        }

                    } else {
                        formContainer.find('.form-error-msg').html(data.message).fadeIn();
                        formContainer.find('.form-success-msg').fadeOut();
                    }
                });

                deferred_request.fail(function( data ) {
                    console.log('Failed AJAX Call :( /// Return Data: ' + data);

                    form.find(".form-btn").removeClass('loading');
                    formContainer.find('.form-error-msg').html('<h4>Error</h4><p>Something went wrong. Please try again later.</p>').fadeIn();
                    formContainer.find('.form-success-msg').fadeOut();


                });
            });
        }
    },
    destroyContactEnquiryForm: function () {
        var _this = this;
        $(document).off('submit', _this.contactEnquiryEl);
    },
    leadGenFormEl: '.liquid_lead_gen_form',
    initLeadGenForm: function () {
        var _this = this;
        if($(_this.leadGenFormEl).length) {
            // === Lead Gen FORM
            $(document).on('submit', _this.leadGenFormEl, function (e) {
                e.preventDefault();

                if ($(this).find('button[type="submit"]').hasClass("disabled")) {
                    return;
                }

                if ( !$(this).parsley().isValid() ) { return; }

                var form = $(this);
                var formContainer = $(this).parent('.form-container');

                // show spinner
                // form.find(".form-btn .spinner").removeClass('is-hidden');
                form.find(".form-btn").addClass('loading');

                var formData = $(this).serialize() + '&action=process_liquid_lead_gen_form';

                var deferred_request = $.ajax({
                    method: "POST",
                    url: admin_ajax_url,
                    data: formData,
                    datatype: "JSON"
                });

                deferred_request.done(function (data) {

                    data = $.parseJSON(data);

                    // hide spinner
                    //form.find(".form-btn .spinner").addClass('is-hidden');
                    form.find(".form-btn").removeClass('loading');

                    if (data.success) {
                        // form.hide();
                        form.addClass('off');
                        formContainer.find('.form-success-msg').html(data.message).fadeIn();
                        formContainer.find('.form-error-msg').fadeOut();

                        if(typeof ga === 'function') {
                            ga('send', 'pageview', '/insights/successful-enquiry');
                        }

                    } else {
                        formContainer.find('.form-error-msg').html(data.message).fadeIn();
                        formContainer.find('.form-success-msg').fadeOut();
                    }
                });

                deferred_request.fail(function (data) {
                    console.log('Failed AJAX Call :( /// Return Data: ' + data);

                    form.find(".form-btn").removeClass('loading');
                    formContainer.find('.form-error-msg').html('<h4>Error</h4><p>Something went wrong. Please try again later.</p>').fadeIn();
                    formContainer.find('.form-success-msg').fadeOut();


                });
            });
        }
    },
    destroyLeadGenForm: function () {
        var _this = this;
        $(document).off('submit', _this.leadGenFormEl);
    },
    downloadFormEl: '.liquid_download_form',
    initDownloadForm: function () {
        var _this = this;
        if($(_this.downloadFormEl).length) {
            $(document).on('submit', _this.downloadFormEl, function (e) {
                e.preventDefault();

                if ($(this).find('button[type="submit"]').hasClass("disabled")) {
                    return;
                }

                if ( !$(this).parsley().isValid() ) { return; }

                var form = $(this);
                var formContainer = $(this).parent('.form-container');

                form.find(".form-btn").addClass('loading');

                var formData = $(this).serialize() + '&action=process_liquid_download_form';

                var deferred_request = $.ajax({
                    method: "POST",
                    url: admin_ajax_url,
                    data: formData,
                    datatype: "JSON"
                });

                deferred_request.done(function (data) {
                    data = $.parseJSON(data);
                    form.find(".form-btn").removeClass('loading');

                    if (data.success) {
                        var message = '<h4><b>Thank you</b></h4>';
                        form.addClass('off');
                        formContainer.parent().parent().find('h3').text('Thank you for downloading the latest Market Pulse.');
                        formContainer.find('.form-success-msg').html(message).fadeIn();
                        formContainer.find('.form-error-msg').fadeOut();

                        if(typeof ga === 'function') {
                            ga('send', 'pageview', '/insights/successful-enquiry');
                        }

                        var url = data.report;

                        const a = document.createElement("a");
                        a.style.display = "none";
                        a.href = url;
                        a.target = '_blank';
                        a.download = url;

                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    } else {
                        formContainer.find('.form-error-msg').html(data.message).fadeIn();
                        formContainer.find('.form-success-msg').fadeOut();
                    }
                });

                deferred_request.fail(function (data) {
                    console.log('Failed AJAX Call :( /// Return Data: ' + data);

                    form.find(".form-btn").removeClass('loading');
                    formContainer.find('.form-error-msg').html('<h4>Error</h4><p>Something went wrong. Please try again later.</p>').fadeIn();
                    formContainer.find('.form-success-msg').fadeOut();
                });
            });
        }
    },
    destroyDownloadForm: function () {
        var _this = this;
        $(document).off('submit', _this.downloadFormEl);
    },
    subscriptionFormEl: '.liquid_subscription_form',
    initSubscriptionForm: function () {
        var _this = this;
        if($(_this.subscriptionFormEl).length) {
            // === Subscription FORM
            $(document).on('submit', _this.subscriptionFormEl, function(e) {
                e.preventDefault();

                if($(this).find('button[type="submit"]').hasClass( "disabled" )) { return; }
                if ( !$(this).parsley().isValid() ) { return; }

                var form = $(this);
                var formContainer = $(this).parent('.form-container');

                // show spinner
                // form.find(".form-btn .spinner").removeClass('is-hidden');
                form.find(".form-btn").addClass('loading');

                var formData = $(this).serialize() + '&action=process_liquid_subscription_form';

                var deferred_request = $.ajax({
                    method: "POST",
                    url: admin_ajax_url,
                    data: formData,
                    datatype: "JSON"
                });

                deferred_request.done(function( data ) {

                    data = $.parseJSON(data);

                    // hide spinner
                    //form.find(".form-btn .spinner").addClass('is-hidden');
                    form.find(".form-btn").removeClass('loading');

                    if(data.success) {
                        // form.hide();
                        form.addClass('off');
                        formContainer.find('.form-success-msg').html(data.message).fadeIn();;
                        formContainer.find('.form-error-msg').fadeOut();

                        if(typeof ga === 'function') {
                            ga('send', 'pageview', '/insights/successful-enquiry');
                        }
                    } else {
                        formContainer.find('.form-error-msg').html(data.message).fadeIn();
                        formContainer.find('.form-success-msg').fadeOut();
                    }
                });

                deferred_request.fail(function( data ) {
                    console.log('Failed AJAX Call :( /// Return Data: ' + data);

                    form.find(".form-btn").removeClass('loading');
                    formContainer.find('.form-error-msg').html('<h4>Error</h4><p>Something went wrong. Please try again later.</p>').fadeIn();
                    formContainer.find('.form-success-msg').fadeOut();


                });
            });
        }
    },
    destroySubscriptionForm: function () {
        var _this = this;
        $(document).off('submit', _this.subscriptionFormEl);
    },
    productProjectEnquiryEl: '.liquid_project_product_enquire_form',
    initProductProjectEnquiryForm: function () {
        var _this = this;
        if($(_this.productProjectEnquiryEl).length) {
            //project product enquire form
            $(document).on('submit', _this.productProjectEnquiryEl, function(e) {
                e.preventDefault();

                if($(this).find('button[type="submit"]').hasClass( "disabled" )) { return; }
                if ( !$(this).parsley().isValid() ) { return; }

                var form = $(this);
                var formContainer = $(this).parent('.form-container');

                // show spinner
                // form.find(".form-btn .spinner").removeClass('is-hidden');
                form.find(".form-btn").addClass('loading');

                var formData = $(this).serialize() + '&action=process_liquid_project_product_enquire_form';

                var deferred_request = $.ajax({
                    method: "POST",
                    url: admin_ajax_url,
                    data: formData,
                    datatype: "JSON"
                });

                deferred_request.done(function( data ) {

                    data = $.parseJSON(data);

                    // hide spinner
                    //form.find(".form-btn .spinner").addClass('is-hidden');
                    form.find(".form-btn").removeClass('loading');

                    if(data.success) {
                        // form.hide();
                        form.addClass('off');
                        formContainer.find('.form-success-msg').html(data.message).fadeIn();;
                        formContainer.find('.form-error-msg').fadeOut();

                        if(typeof ga === 'function') {
                            ga('send', 'pageview', '/' + data.slug + '/successful-project-enquiry');
                        }
                    } else {
                        formContainer.find('.form-error-msg').html(data.message).fadeIn();
                        formContainer.find('.form-success-msg').fadeOut();
                    }
                });

                deferred_request.fail(function( data ) {
                    console.log('Failed AJAX Call :( /// Return Data: ' + data);

                    form.find(".form-btn").removeClass('loading');
                    formContainer.find('.form-error-msg').html('<h4>Error</h4><p>Something went wrong. Please try again later.</p>').fadeIn();
                    formContainer.find('.form-success-msg').fadeOut();


                });
            });
        }
    },
    destroyProductProjectEnquiryForm: function () {
        var _this = this;
        $(document).off('submit', _this.productProjectEnquiryEl);
    },
    startAProjectCardEl: '.liquid_start_a_project_form_card',
    initStartAProjectFormCard: function () {
        var _this = this;
        if($(_this.startAProjectCardEl).length) {
            //project product enquire form
            // $(document).on('submit', _this.startAProjectEl, function(e) {
            $(_this.startAProjectCardEl).on('submit', function(e) {
                e.preventDefault();

                if($(this).find('button[type="submit"]').hasClass( "disabled" )) { return; }
                if ( !$(this).parsley().isValid() ) { return; }

                var form = $(this);
                var formContainer = $(this).parent('.form-container');
                var successMsg = formContainer.find('.success-msg');
                var formTitle = formContainer.find('.form-title');

                if(formContainer.find("#budget-sqm").hasClass('active')) {
                    formContainer.find("#pa_min").val('');
                    formContainer.find("#pa_max").val('');
                    if(formContainer.find("#sqm_pa_min").val() == "") {
                        formContainer.find("#sqm_pa_min").val('10000');
                    }
                    if(formContainer.find("#sqm_pa_max").val() == "") {
                        formContainer.find("#sqm_pa_max").val('1000000');
                    }
                }

                // show spinner
                // form.find(".form-btn .spinner").removeClass('is-hidden');
                form.find(".form-btn").addClass('loading');
                form.find('.spinner').addClass('animate');

                var formData = $(this).serialize() + '&action=process_liquid_start_project_form';

                var deferred_request = $.ajax({
                    method: "POST",
                    url: admin_ajax_url,
                    data: formData,
                    datatype: "JSON"
                });

                deferred_request.done(function( data ) {

                    data = $.parseJSON(data);

                    // hide spinner
                    //form.find(".form-btn .spinner").addClass('is-hidden');
                    form.find(".form-btn").removeClass('loading');

                    if(data.success) {
                        form.hide();
                        $('.start-project-grey-bg').addClass('full');
                        // form.addClass('off');
                        formTitle.addClass('hide');
                        successMsg.addClass('show');
                        formContainer.find('.form-error-msg').fadeOut();

                        if(typeof ga === 'function') {
                            ga('send', 'pageview', '/offices-for-lease');
                        }
                    } else {
                        formContainer.find('.form-error-msg').html(data.message).fadeIn();
                        // formContainer.find('.form-success-msg').fadeOut();
                    }
                });

                deferred_request.fail(function( data ) {
                    console.log('Failed AJAX Call :( /// Return Data: ' + data);

                    form.find(".form-btn").removeClass('loading');
                    formContainer.find('.form-error-msg').html('<h4>Error</h4><p>Something went wrong. Please try again later.</p>').fadeIn();
                    formContainer.find('.form-success-msg').fadeOut();


                });
            });

            // $(document).off().on('click', ".decrement", function(e) {
            $(_this.startAProjectEl).find('.decrement').off('click').on('click', function(e) {
                var $button = $(this);
                var oldValue = $button.parent().find("input").val();

                oldValue = parseInt(oldValue) || 0;
                // Don't allow decrementing below zero
                if (oldValue > 0) {
                    var newVal = oldValue - 1;
                } else {
                    newVal = 0;
                }
                $button.parent().find("input").val(newVal);
            });

            // $(document).off().on('click', ".increment", function(e) {
            $(_this.startAProjectEl).find('.increment').off('click').on('click', function(e) {
                var $button = $(this);
                var oldValue = $button.parent().find("input").val();

                oldValue = parseInt(oldValue) || 0;
                var newVal = oldValue + 1;

                $button.parent().find("input").val(newVal);
            });
        }
    },
    startAProjectEl: '.liquid_start_a_project_form',
    initStartAProjectForm: function () {
        var _this = this;
        if($(_this.startAProjectEl).length) {
            //project product enquire form
            // $(document).on('submit', _this.startAProjectEl, function(e) {
            $(_this.startAProjectEl).on('submit', function(e) {
                e.preventDefault();

                if($(this).find('button[type="submit"]').hasClass( "disabled" )) { return; }
                if ( !$(this).parsley().isValid() ) { return; }

                var form = $(this);
                var formContainer = $(this).parent('.form-container');

                if(formContainer.find("#budget-sqm").hasClass('active')) {
                    formContainer.find("#pa_min").val('');
                    formContainer.find("#pa_max").val('');
                    if(formContainer.find("#sqm_pa_min").val() == "") {
                        formContainer.find("#sqm_pa_min").val('10000');
                    }
                    if(formContainer.find("#sqm_pa_max").val() == "") {
                        formContainer.find("#sqm_pa_max").val('1000000');
                    }
                }

                // show spinner
                // form.find(".form-btn .spinner").removeClass('is-hidden');
                form.find(".form-btn").addClass('loading');
                form.find('.spinner').addClass('animate');

                var formData = $(this).serialize() + '&action=process_liquid_start_project_form';

                var deferred_request = $.ajax({
                    method: "POST",
                    url: admin_ajax_url,
                    data: formData,
                    datatype: "JSON"
                });

                deferred_request.done(function( data ) {

                    data = $.parseJSON(data);

                    // hide spinner
                    //form.find(".form-btn .spinner").addClass('is-hidden');
                    form.find(".form-btn").removeClass('loading');

                    if(data.success) {
                        form.hide();
                        $('.start-project-grey-bg').addClass('full');
                        // form.addClass('off');
                        formContainer.find('form-success-msg').html(data.message).fadeIn();
                        formContainer.find('.form-error-msg').fadeOut();

                        if(typeof ga === 'function') {
                            ga('send', 'pageview', '/find-my-space/successful-enquiry');
                        }
                    } else {
                        formContainer.find('.form-error-msg').html(data.message).fadeIn();
                        formContainer.find('.form-success-msg').fadeOut();
                    }
                });

                deferred_request.fail(function( data ) {
                    console.log('Failed AJAX Call :( /// Return Data: ' + data);

                    form.find(".form-btn").removeClass('loading');
                    formContainer.find('.form-error-msg').html('<h4>Error</h4><p>Something went wrong. Please try again later.</p>').fadeIn();
                    formContainer.find('.form-success-msg').fadeOut();


                });
            });

            // $(document).off().on('click', ".decrement", function(e) {
            $(_this.startAProjectEl).find('.decrement').off('click').on('click', function(e) {
                var $button = $(this);
                var oldValue = $button.parent().find("input").val();

                oldValue = parseInt(oldValue) || 0;
                // Don't allow decrementing below zero
                if (oldValue > 0) {
                    var newVal = oldValue - 1;
                } else {
                    newVal = 0;
                }
                $button.parent().find("input").val(newVal);
            });

            // $(document).off().on('click', ".increment", function(e) {
            $(_this.startAProjectEl).find('.increment').off('click').on('click', function(e) {
                var $button = $(this);
                var oldValue = $button.parent().find("input").val();

                oldValue = parseInt(oldValue) || 0;
                var newVal = oldValue + 1;

                $button.parent().find("input").val(newVal);
            });
        }
    },
    destroyStartAProjectForm: function () {
        var _this = this;
        // $(document).off('submit', _this.startAProjectEl);
        $(_this.startAProjectEl).off('submit');
        $(_this.startAProjectEl).find('.decrement').off('click');
        $(_this.startAProjectEl).find('.increment').off('click');
    },
    writeCookie: function(name, value, exp_days){
        var date = new Date();
        var days = exp_days || 365;
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        window.document.cookie = name + "=" + value + "; expires=" + date.toGMTString() + "; path=/";
    },

    readCookie: function(name){
            var nameEQ = name + "=";
        var ca = window.document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },

    removeCookie: function(name){
        var _this = this;
        _this.writeCookie(name, "", -1);
    },
    sitePopupEl: '.liquid_popup_form_step_one',
    popupActiveForm: 1,
    persistentSubmissionId: null,
    sitePopupElStepTwo: '.liquid_popup_form_step_two',
    sitePopupProgressBar: '.site_popup_progress_bar',
    sitePopupThankYou: '.site_popup_thank_you',
    sitePopupFormContent: '.site_popup_form_content',
    popupStepOneCopy: '.copy-step-1',
    popupStepTwoCopy: '.copy-step-2',
    initSitePopupForm: function (parsleyOptions) {
        var _this = this;
        if($(_this.sitePopupEl).length) {
            var stepOneCounter = $(_this.sitePopupProgressBar).find('.step-1');
            var stepTwoCounter = $(_this.sitePopupProgressBar).find('.step-2');
            var stepOneNumber = $(stepOneCounter).find('.step-number');
            $(_this.sitePopupThankYou).hide();
            $(_this.sitePopupFormContent).show();

            if (this.popupActiveForm === 1) {
                $(_this.sitePopupElStepTwo).hide();
                $(_this.sitePopupEl).show();
                stepOneCounter.addClass('current');
                stepOneCounter.removeClass('completed');
                stepTwoCounter.removeClass('current');
                stepOneNumber.find('.number').show();
                stepOneNumber.find('.icon').hide();
                $(_this.popupStepTwoCopy).hide();
                $(_this.popupStepOneCopy).show();
            } else {
                $(_this.sitePopupEl).hide();
                $(_this.sitePopupElStepTwo).show();
                stepOneCounter.addClass('completed');
                stepTwoCounter.addClass('current');
                stepOneCounter.removeClass('current');
                stepOneNumber.find('.number').hide();
                stepOneNumber.find('.icon').show();
                $(_this.popupStepTwoCopy).show();
                $(_this.popupStepOneCopy).hide();
            }

            _this.display_popup = true;
            var _MS_PER_DAY = 1000 * 60 * 60 * 24;//millisecond per day
            // a and b are javascript Date objects
            function dateDiffInDays(a, b) {
                if(!a) a=b;
                // Discard the time and time-zone information.
                var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
                var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

                return Math.floor((utc2 - utc1) / _MS_PER_DAY);
            }

            var postId = $('#wp-body-div').attr('data-post-id');
            $('#site_popup_current_page_id').val(postId); //update the page id in site popup hidden field

            if($liquid_popup_enabled!='1') {
                _this.popup_disabled = true;
                return;
            } else {
                if($display_on == 'all') {
                    _this.popup_disabled = false;
                } else if($('div.home').length && $display_on == 'homepage') {
                    _this.popup_disabled = false;
                } else if($('div.page-id-722').length && $display_on == 'leasepage') {
                    _this.popup_disabled = false;
                } else {
                    _this.popup_disabled = true;
                }
            }

            var popup_shown_on = storageSupported?localStorage.getItem("liquid_popup_shown"):_this.readCookie("liquid_popup_shown");
            var popup_submitted_on = storageSupported?localStorage.getItem("liquid_popup_submitted"):_this.readCookie("liquid_popup_submitted");
            var popup_reset_on = storageSupported?localStorage.getItem("liquid_popup_reset_date"):_this.readCookie("liquid_popup_reset_date"); //user popup reset date

            if($liquid_popup_reset_date) {
                var form_reset_clicked_on = new Date($liquid_popup_reset_date);
            } else {
                var form_reset_clicked_on = false;
            }

            if(form_reset_clicked_on) {//admin clicked reset
                if(popup_reset_on){
                    var reset_date_diff = dateDiffInDays(new Date(popup_reset_on), new Date(form_reset_clicked_on));
                    if(reset_date_diff > 0) { //admin reset date is greater than user reset date
                        _this.display_popup = true;
                        _this.reset_popup = true;
                    } else { //user reset date is greater than admin reset date
                        if(popup_shown_on ) {
                            var current_data = new Date();

                            popup_shown_on = new Date(popup_shown_on);
                            var day_diff = dateDiffInDays(popup_shown_on, current_data);

                            if(popup_submitted_on) { //if form submitted don't so popup agian unless reset is ticked
                                _this.display_popup = false;
                            } else if(day_diff < $display_again_after) { // display after set amount of days if form not submitted
                                _this.display_popup = false;
                            }
                        }
                    }

                } else {
                    _this.display_popup = true;
                    _this.reset_popup = true;
                }

            } else {
                if(popup_shown_on ) {
                    var current_data = new Date();

                    popup_shown_on = new Date(popup_shown_on);
                    var day_diff = dateDiffInDays(popup_shown_on, current_data);

                    if(popup_submitted_on) { //if form submitted don't so popup agian unless reset is ticked
                        _this.display_popup = false;
                    } else if(day_diff < $display_again_after) { // display after set amount of days if form not submitted
                        _this.display_popup = false;
                    }
                }
            }

            //check if parsley if available, if not initialize it
            if(typeof($(_this.sitePopupEl).parsley()) !== typeof(Function)) {
                $(_this.sitePopupEl).parsley(parsleyOptions);
            }

            $(_this.sitePopupEl).on('submit', function(e) {
                e.preventDefault();

                var form = $(this);

                if(form.find(".form-btn").hasClass('disabled')) {
                    return;
                }

                form.find(".form-btn").addClass('loading').addClass('disabled');
                form.find('.form-error-msg').hide();

                if(!form.parsley().validate()) {
                    return;
                }

                var formData = form.serialize() + '&action=process_liquid_start_project_form';

                var deferred_request = $.ajax({
                    method: "POST",
                    url: admin_ajax_url,
                    data: formData,
                    datatype: "JSON"
                });

                deferred_request.done(function( data ) {
                    data = $.parseJSON(data);
                    form.find(".form-btn").removeClass('loading').removeClass('disabled');

                    if(data.success) {
                        if(storageSupported) {
                            localStorage.setItem("liquid_popup_submitted", new Date());
                        } else {
                            _this.writeCookie("liquid_popup_submitted", new Date());
                        }

                        _this.popupActiveForm = 2;
                        _this.persistentSubmissionId = data.id;
                        $(_this.sitePopupEl).hide();
                        $(_this.sitePopupElStepTwo).show();
                        stepOneCounter.addClass('completed');
                        stepTwoCounter.addClass('current');
                        stepOneCounter.removeClass('current');
                        stepOneNumber.find('.number').hide();
                        stepOneNumber.find('.icon').show();
                        $(_this.popupStepTwoCopy).show();
                        $(_this.popupStepOneCopy).hide();

                        if(typeof ga === 'function') {
                            ga('send', 'pageview', '/pop-up/successful-enquiry');
                        }
                    } else {
                        form.find('.form-error-msg').html(data.message).fadeIn();
                        form.find('.form-success-msg').fadeOut();
                    }
                });

                deferred_request.fail(function( data ) {
                    form.find(".form-btn").removeClass('loading').removeClass('disabled');
                    form.find('button[type="submit"]').removeClass('disabled');
                    console.log('Failed AJAX Call :( /// Return Data: ' + data);
                });
            });

            $(_this.sitePopupElStepTwo).on('submit', function(e) {
                e.preventDefault();

                var form = $(this);

                if(form.find(".form-btn").hasClass('disabled')) {
                    return;
                }

                form.find(".form-btn").addClass('loading').addClass('disabled');
                form.find('.form-error-msg').hide();

                if(!form.parsley().validate()) {
                    return;
                }

                var formData = form.serialize() + '&action=process_liquid_start_project_form' + '&id=' + _this.persistentSubmissionId;

                var deferred_request = $.ajax({
                    method: "POST",
                    url: admin_ajax_url,
                    data: formData,
                    datatype: "JSON"
                });

                deferred_request.done(function( data ) {
                    data = $.parseJSON(data);
                    form.find(".form-btn").removeClass('loading').removeClass('disabled');

                    if(data.success) {
                        $(_this.sitePopupFormContent).hide();
                        $(_this.sitePopupThankYou).show();
                    } else {
                        form.find('.form-error-msg').html(data.message).fadeIn();
                        form.find('.form-success-msg').fadeOut();
                    }
                });

                deferred_request.fail(function( data ) {
                    form.find(".form-btn").removeClass('loading').removeClass('disabled');
                    form.find('button[type="submit"]').removeClass('disabled');
                    console.log('Failed AJAX Call :( /// Return Data: ' + data);
                });
            });

            // $(".modal-close").on('click', function (e) {
            $("#site_popup").on('hide.bs.modal', function(){
                if ( $(_this.sitePopupEl).length > 0 ) {
                    $(_this.sitePopupEl).parsley().reset();
                }
            });

            // === CLOSE SITEPOPUP MODAL ON CLICK ON OVERLAY
            $("#site_popup").on('click', function (e) {
                var modal = $(this);
                if ( $(e.target).hasClass('modal-dialog') || $(e.target).hasClass('modal-overlay') ) {
                    modal.find('.modal-close').trigger('click');
                }
            });

        }
    },
    displaySitePopup: function() {
        var _this = this;
        if ($( "#site_popup" ).length < 1) { return; }
        if(_this.display_popup) {
            if(!_this.popup_disabled) {
                sitepopup_timer = setTimeout(function() {
                    $( "#site_popup" ).modal('show');
                    storageSupported?localStorage.setItem("liquid_popup_shown", new Date()):_this.writeCookie("liquid_popup_shown", new Date());
                    if(_this.reset_popup) {
                        storageSupported?localStorage.setItem("liquid_popup_reset_date", new Date()):_this.writeCookie("liquid_popup_reset_date", new Date());
                        storageSupported?localStorage.removeItem("liquid_popup_submitted"):_this.deleteCookie("liquid_popup_submitted");
                    }
                }, $display_after * 1000);
            }
        }
    },
    destroySitePopupForm: function() {
        var _this = this;
        $(_this.sitePopupEl).off('submit');
        clearTimeout(sitepopup_timer);
    },
    callNowEl: '.liquid_callus_form',
    initCallNowForm: function () {
        var _this = this;
        if($(_this.callNowEl).length) {
            // === Enquiry FORM
            $(_this.callNowEl).submit( function(e) {
                e.preventDefault();
                $(_this.callNowEl).parsley().validate();
                var valid = $(_this.callNowEl).parsley ( 'validate' );

                if ( !$(this).parsley().isValid() ) { return; }

                if($(this).find('button[type="submit"]').hasClass( "disabled" )) { return; }

                var form = $(this);
                var formContainer = $(this).parent('.form-container');

                // show spinner
                // form.find(".form-btn .spinner").removeClass('is-hidden');
                form.find(".form-btn").addClass('loading');

                var formData = $(this).serialize() + '&action=process_liquid_enquiry_form&callnow=true';

                var deferred_request = $.ajax({
                    method: "POST",
                    url: admin_ajax_url,
                    data: formData,
                    datatype: "JSON"
                });

                deferred_request.done(function( data ) {

                    data = $.parseJSON(data);

                    // hide spinner
                    //form.find(".form-btn .spinner").addClass('is-hidden');
                    form.find(".form-btn").removeClass('loading');

                    if(data.success) {
                        // form.hide();
                        form.addClass('off');
                        formContainer.find('.form-success-msg').html(data.message).fadeIn();;
                        formContainer.find('.form-error-msg').fadeOut();
                    } else {
                        formContainer.find('.form-error-msg').html(data.message).fadeIn();
                        formContainer.find('.form-success-msg').fadeOut();
                    }
                });

                deferred_request.fail(function( data ) {
                    console.log('Failed AJAX Call :( /// Return Data: ' + data);

                    form.find(".form-btn").removeClass('loading');
                    formContainer.find('.form-error-msg').html('<h4>Error</h4><p>Something went wrong. Please try again later.</p>').fadeIn();
                    formContainer.find('.form-success-msg').fadeOut();


                });
            });

            $("#call_us_now_btn").on('click', function (e) {
                $( "#call_request_modal" ).modal('show');
            });

            // $(".modal-close").on('click', function (e) {
            $("#call_request_modal").on('hide.bs.modal', function(){
                if ( $(_this.callNowEl).length > 0 ) {
                    $(_this.callNowEl).parsley().reset();
                }
            });

            // === CLOSE SITEPOPUP MODAL ON CLICK ON OVERLAY
            $("#call_request_modal").on('click', function (e) {
                var modal = $(this);
                if ( $(e.target).hasClass('modal-dialog') || $(e.target).hasClass('modal-overlay') ) {
                    modal.find('.modal-close').trigger('click');
                }
            });
        }
    },
    destroyCallNowForm: function () {
        var _this = this;
        $(_this.callNowEl).off('submit');
        $("#call_us_now_btn").off('click');
    },

}
